module.exports = __webpack_public_path__ + "static/media/help-tap-to-fill-white.b3d50883.png";